import React, { useState, useContext, useEffect } from "react";
import firebase from "firebase";
import { AudioContext } from "../../contexts/AudioContext";
import { AuthContext } from "../../Auth";
import { useHistory } from "react-router-dom";
import "./style.scss";

const Avatar = () => {
  const [isGuest, setGuest] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const audioContext = useContext(AudioContext);
  const history = useHistory();
  const audio = new Audio(require("../../assets/audio/loading.mp3"));
  const db = firebase.firestore();
  useEffect(() => {
    if (authContext.currentUser) {
      if (localStorage.guestScore) {
        localStorage.score = localStorage.guestScore;
        setGuest(true);
      }
    } else {
      history.push("/");
    }
    return () => {
      localStorage.guestScore = "";
      localStorage.guestStatus = "";
    };
  }, []);

  const handleClickImage = (index) => {
    setLoading(true);
    audioContext.volumeDown();
    audio.volume = 0.5;
    audio.loop = true;
    audio.play();
    if (index !== -1) {
      const storage = firebase.storage();
      const storageRef = storage.ref(`avatars/${index}.svg`);
      storageRef.getDownloadURL().then((url) => {
        localStorage.photo = url;
        db.collection("users")
          .doc(localStorage.email)
          .update({
            score: isGuest ? parseFloat(localStorage.guestScore) : 0,
            lastScore: isGuest ? parseFloat(localStorage.guestScore) : 0,
            lastStatus: isGuest ? localStorage.guestStatus : "unlucky",
            photo: url,
          })
          .then(() => {
            audio.pause();
            audio.currentTime = 0;
            audioContext.volumeUp();
            setLoading(false);
            history.push(
              isGuest ? "/chart" : "/luckygame",
              isGuest ? "rank" : ""
            );
          });
      });
    } else {
      db.collection("users")
        .doc(localStorage.email)
        .update({
          score: isGuest ? parseFloat(localStorage.guestScore) : 0,
          lastScore: isGuest ? parseFloat(localStorage.guestScore) : 0,
          lastStatus: isGuest ? localStorage.guestStatus : "unlucky",
        })
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
          audioContext.volumeUp();
          setLoading(false);
          history.push(
            isGuest ? "/chart" : "/luckygame",
            isGuest ? "rank" : ""
          );
        });
    }
  };
  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <img
            alt="loader"
            src={require(`../../assets/images/SVG/1.svg`)}
            className="loader"
          ></img>
          <div>LOADING LUCKY PAD...</div>
        </div>
      ) : (
        ""
      )}
      <div
        className="avatar"
        style={isLoading ? { opacity: 0 } : { opacity: 1 }}
      >
        <img
          alt="logo"
          className="avatar-logo"
          src={require("./../../assets/images/logo.svg")}
        ></img>
        <div className="avatar-header">
          <div>Choose your profile picture or avatar </div>
          <div
            style={{ fontSize: "14px", marginTop: "10px", fontWeight: "500" }}
          >
            You can always change it later.
          </div>
          <div
            className="avatar-header-image"
            onClick={() => handleClickImage(-1)}
          >
            <img
              alt="profile"
              className="avatar-header-image-profile"
              src={localStorage.photo}
            ></img>
            <div className="avatar-header-image-overlay"></div>
          </div>
        </div>
        <div className="avatar-body">
          <div>or</div>
          <div className="avatar-body-group">
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(0)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/0.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(1)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/1.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(2)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/2.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(3)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/3.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
          </div>
          <div className="avatar-body-group">
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(4)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/4.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(5)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/5.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(6)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/6.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(7)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/7.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
          </div>
          <div className="avatar-body-group">
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(8)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/8.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(9)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/9.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(10)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/10.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
            <div
              className="avatar-body-group-image"
              onClick={() => handleClickImage(11)}
            >
              <img
                alt="avatar1"
                src={require("./../../assets/images/11.svg")}
              ></img>
              <div className="avatar-body-group-image-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Avatar;
